import { useEffect, useMemo, useState } from "react";
import "./bill-portal.style.scss";
import { useNavigate, useLocation } from "react-router-dom";

import jwt_decode from "jwt-decode";

// components
import BillViewPrint from "../../components/bill-portal/bill-view-print/bill-view-print.component";

// The decoded token's real shape is unconfirmed — see bill-view-print.component.tsx's
// own note. Left as a loose record rather than invented, matching current
// (unverified) behavior exactly.
export default function PortalRedirect() {
	const [billData, setBillData] = useState<Record<string, unknown>>({});

	const location = useLocation();
	const navigate = useNavigate();

	const token = useMemo(() => {
		const params = new URLSearchParams(location.search);
		return params.get("token");
	}, [location.search]);

	useEffect(() => {
		if (token) {
			const decoded = jwt_decode(token) as Record<string, unknown>;

			setBillData(decoded);
		} else {
			navigate("/login");
		}
	}, [token, navigate]);

	return (
		<div className="billing-portal">
			<BillViewPrint billData={billData} token={token} />
		</div>
	);
}
